module.exports = __webpack_public_path__ + "img/liuzeyuan.a7f2da03.jpg";